// extracted by mini-css-extract-plugin
export default {"segmentCard":"SegmentCard_segmentCard__d5gkK","beer":"SegmentCard_beer__88oxe","hardBev":"SegmentCard_hardBev__JOxcJ","segmentTitle":"SegmentCard_segmentTitle__GXyBm"};